import { Cookies } from 'react-cookie';
import jwt from 'jwt-decode';
import { isNullOrUndefined } from 'util';

//start copy Hunter's Code
export const isBrowser = typeof window !== `undefined`;

export const isLocalhost = isBrowser ? document.location.hostname === 'localhost' : false;

export const cookieDomain = isLocalhost ? 'localhost' : '.suitedconnector.com';

export const TOKEN_NAME_KEY =
  !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? 'dev-token' : 'token';

export const USER_NAME_KEY = 'JWT_USERNAME';

const getToken = (token_key: string = TOKEN_NAME_KEY) => {
  const cookies = new Cookies(document.cookie);
  const token = cookies.get(token_key);
  return token;
};

const setToken = (token: string) => {
  const cookies = new Cookies(document.cookie);
  cookies.set(TOKEN_NAME_KEY, token, {
    domain: cookieDomain,
  });
};

export const getTokenValue = () => {
  return (isBrowser ? getToken() : undefined) || localStorage.getItem(TOKEN_NAME_KEY);
};

export const getUserName = () => {
  return (
    (isBrowser ? getToken(USER_NAME_KEY) : undefined) ||
    localStorage.getItem(USER_NAME_KEY) ||
    'Admin'
  );
};

export const clearStore = () => {
  const cookies = new Cookies(document.cookie);
  cookies.remove(TOKEN_NAME_KEY, {
    domain: cookieDomain,
  });
};

export const handleLogin = (token: string) => {
  if (!isBrowser) return false;
  return setToken(token);
};

export const isLoggedIn = () => {
  if (isBrowser) {
    try {
      const token = getToken();
      const decToken = jwt(token);
      const timeRem = decToken.exp - Math.round(Date.now() / 1000);
      if (timeRem > 0) return true;
      else {
        clearStore();
        return false;
      }
    } catch {
      clearStore();
      return false;
    }
  } else {
    //consult local storage
    return !isNullOrUndefined(localStorage.getItem(TOKEN_NAME_KEY));
  }
};

export const tokenizedHeader = () => ({
  Authorization: 'bearer ' + getTokenValue(),
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'Access-Control-Allow-Origin': '*',
});

//end copy Hunter's code
